// The catalogue that seeds D1 the first time the shop runs. The admin panel
// takes over from there, so this file is a starting assortment, not a source of
// truth. Photos live in public/images; prices are in so‘m.

export type Category = 'mayiz' | 'turshak' | 'orik' | 'olxori' | 'xurmo' | 'anjir' | 'yongoq' | 'assorti' | 'qoqilar' | 'finik'

export const categories: { key: Category; label: string; image: string; blurb: string }[] = [
  { key: 'mayiz', label: 'Mayiz', image: '/images/mayiz.webp', blurb: 'Quyoshda quritilgan uzum' },
  { key: 'turshak', label: 'Turshak', image: '/images/turshak.webp', blurb: 'Daraxtda pishgan o‘rik' },
  { key: 'orik', label: 'Quritilgan o‘rik', image: '/images/orik.webp', blurb: 'Yumshoq va sershira' },
  { key: 'olxori', label: 'Olxo‘ri qoqi', image: '/images/olxori.webp', blurb: 'Dudlangan ta’mli qoqi' },
  { key: 'xurmo', label: 'Xurmo', image: '/images/xurmo.webp', blurb: 'Sharqning shirin xurmosi' },
  { key: 'anjir', label: 'Anjir', image: '/images/anjir.webp', blurb: 'Asal ta’mli quritilgan anjir' },
  { key: 'yongoq', label: 'Yong‘oqlar', image: '/images/yongoq.webp', blurb: 'Yangi yorilgan, toza mag‘iz' },
  { key: 'assorti', label: 'Mevalar assortimenti', image: '/images/assorti.webp', blurb: 'Sovg‘a uchun saralangan to‘plam' },
  { key: 'qoqilar', label: 'Boshqa qoqilar', image: '/images/assorti.webp', blurb: 'Turli quritilgan mevalar' },
  { key: 'finik', label: 'Finik', image: '/images/xurmo.webp', blurb: 'Tabiiy shirin finik xurmosi' },
]

export interface Product {
  slug: string
  name: string
  /** Omitted when the shop quotes the price in Telegram. */
  price?: number
  compareAt?: number
  category: Category
  image: string
  badge?: 'New' | 'Bestseller' | 'Low stock'
  short: string
  description: string
  details: string[]
  materials: string
  featured?: boolean
}

const originalProducts: Product[] = [
  {
    slug: 'qora-mayiz',
    name: 'Qora mayiz',
    price: 62000,
    category: 'mayiz',
    image: '/images/mayiz.webp',
    badge: 'Bestseller',
    short: 'Mayda, urug‘siz · 500 g',
    description:
      'So‘nggi quyosh ostida quritilgan uzum. Donalari mayda, rangi to‘q, ta’mi esa tabiiy shirin — hech qanday shakar yoki sirop qo‘shilmagan.',
    details: ['Turi: urug‘siz qora mayiz', 'Og‘irligi: 500 g', 'Hosili: Farg‘ona vodiysi', 'Saqlash muddati: 12 oy'],
    materials: 'Tarkibi: 100% quritilgan uzum. Konservant, bo‘yoq va qo‘shimcha shakar yo‘q.',
    featured: true,
  },
  {
    slug: 'quritilgan-orik',
    name: 'Quritilgan o‘rik',
    price: 78000,
    category: 'orik',
    image: '/images/orik.webp',
    badge: 'Bestseller',
    short: 'Yumshoq, sershira · 500 g',
    description:
      'Daraxtda to‘liq pishgandan keyin teriladi, so‘ng soyada sekin quritiladi. Shuning uchun rangi tillarang, eti esa yumshoq va sershira bo‘lib qoladi.',
    details: ['Turi: danaksiz, tabiiy quritilgan', 'Og‘irligi: 500 g', 'Namlik: 18–20%', 'Saqlash muddati: 12 oy'],
    materials: 'Tarkibi: 100% quritilgan o‘rik. Sulfit va konservantlarsiz.',
    featured: true,
  },
  {
    slug: 'turshak',
    name: 'Turshak',
    price: 95000,
    category: 'turshak',
    image: '/images/turshak.webp',
    short: 'Danakli, quyoshda quritilgan · 500 g',
    description:
      'An’anaviy usulda, daraxtda pishgan holda quritilgan o‘rik. Danagi ichida qoladi — shu sababli ta’mi chuqurroq va to‘q rangli bo‘ladi.',
    details: ['Turi: danakli turshak', 'Og‘irligi: 500 g', 'Quritish: quyoshda, qo‘lda saralangan', 'Saqlash: salqin va quruq joyda'],
    materials: 'Tarkibi: 100% quritilgan o‘rik (danagi bilan).',
    featured: true,
  },
  {
    slug: 'olxori-qoqi',
    name: 'Olxo‘ri qoqi',
    price: 68000,
    category: 'olxori',
    image: '/images/olxori.webp',
    badge: 'New',
    short: 'Dudlangan ta’mli, danaksiz · 500 g',
    description:
      'Quyoshda quritilgan olxo‘ri. Rangi qora-yashil, ta’mi esa yengil dud va karamelga o‘xshaydi — choy yoniga eng mos meva.',
    details: ['Turi: danaksiz olxo‘ri qoqi', 'Og‘irligi: 500 g', 'Hosili: Samarqand viloyati', 'Saqlash muddati: 12 oy'],
    materials: 'Tarkibi: 100% quritilgan olxo‘ri.',
    featured: true,
  },
  {
    slug: 'xurmo',
    name: 'Xurmo',
    price: 54000,
    category: 'xurmo',
    image: '/images/xurmo.webp',
    short: 'Yumshoq, asalli · 500 g',
    description:
      'Yetilgan xurmo qo‘lda teriladi va quritiladi. Eti yumshoq, po‘sti yupqa, ta’mi asalga o‘xshaydi. Ertalabki choy uchun eng sara tanlov.',
    details: ['Turi: yumshoq xurmo', 'Og‘irligi: 500 g', 'Danagi: olinmagan', 'Saqlash muddati: 10 oy'],
    materials: 'Tarkibi: 100% quritilgan xurmo.',
  },
  {
    slug: 'anjir',
    name: 'Anjir',
    price: 128000,
    category: 'anjir',
    image: '/images/anjir.webp',
    badge: 'Low stock',
    short: 'Asal ta’mli, qo‘lda terilgan · 500 g',
    description:
      'Kichik partiyalarda quritilgan anjir. Har bir dona qo‘lda saralanadi, shuning uchun meva yorilib ketmaydi va asal ta’mini saqlaydi.',
    details: ['Turi: oq anjir', 'Og‘irligi: 500 g', 'Saralash: qo‘lda', 'Saqlash muddati: 10 oy'],
    materials: 'Tarkibi: 100% quritilgan anjir.',
    featured: true,
  },
  {
    slug: 'yong-oq',
    name: 'Yong‘oq',
    price: 145000,
    category: 'yongoq',
    image: '/images/yongoq.webp',
    short: 'Yangi yorilgan, to‘liq mag‘iz · 500 g',
    description:
      'Po‘stlog‘i qo‘lda yorilgan yong‘oq. Mag‘izi oq, achchiqlik yo‘q, hidi esa yangi — salatga ham, choy yoniga ham birdek yaraydi.',
    details: ['Turi: yupqa po‘stloqli yong‘oq', 'Og‘irligi: 500 g', 'Yorilgan sana: partiya bo‘yicha', 'Saqlash muddati: 8 oy'],
    materials: 'Tarkibi: 100% yong‘oq mag‘izi. Tuz va qo‘shimchalarsiz.',
    featured: true,
  },
  {
    slug: 'bodom',
    name: 'Bodom',
    price: 118000,
    category: 'yongoq',
    image: '/images/bodom.webp',
    short: 'Qovurilmagan, butun mag‘iz · 500 g',
    description:
      'Po‘sti yupqa bodom, qovurilmagan holda qadoqlanadi. Ta’mi yumshoq va sutli, tishlaganda esa yangi hosil ekani seziladi.',
    details: ['Turi: butun bodom', 'Og‘irligi: 500 g', 'Qovurilmagan holatda', 'Saqlash muddati: 8 oy'],
    materials: 'Tarkibi: 100% bodom mag‘izi.',
  },
  {
    slug: 'assorti-toplami',
    name: 'Assorti to‘plami',
    price: 210000,
    compareAt: 240000,
    category: 'assorti',
    image: '/images/assorti.webp',
    short: 'Yog‘och qutida, 5 xil meva · 1 kg',
    description:
      'Mayiz, quritilgan o‘rik, xurmo, olxo‘ri va yong‘oqdan iborat sovg‘a to‘plami. Yog‘och qutida, yumshoq qog‘oz bilan qadoqlangan holda yetkaziladi.',
    details: ['Tarkibi: 5 xil quritilgan meva', 'Og‘irligi: 1 kg', 'Qadoq: yog‘och quti', 'Sovg‘a uchun lenta bilan'],
    materials: 'Tarkibi: quritilgan mevalar va yong‘oq. Qo‘shimcha shakar yo‘q.',
  },
]

export const catalogAdditions: Product[] = [
  {
    slug: 'sariq-kishmish',
    name: 'Sariq kishmish',
    category: 'mayiz',
    image: '/images/mayiz.webp',
    short: 'Oltin rangli, urug‘siz · 500 g',
    description: 'Oltin rangli, mayin ta’mli quritilgan uzum. Urug‘siz kishmish choyga ham, pishiriqlarga ham mos.',
    details: ['Turi: sariq, urug‘siz kishmish', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan uzum.',
    featured: true,
  },
  {
    slug: 'yashil-kishmish',
    name: 'Yashil kishmish',
    category: 'mayiz',
    image: '/images/mayiz.webp',
    short: 'Yirik, urug‘siz · 500 g',
    description: 'Yirik donali, urug‘siz kishmish. Tabiiy shirin ta’mi gazak va shirinliklar uchun juda mos.',
    details: ['Turi: yashil, urug‘siz kishmish', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan uzum.',
  },
  {
    slug: 'urugli-mayiz',
    name: 'Urug‘li mayiz',
    category: 'mayiz',
    image: '/images/mayiz.webp',
    short: 'To‘q rangli, urug‘li · 500 g',
    description: 'Urug‘i bilan quritilgan uzumdan tayyorlangan mayiz. Ta’mi to‘q va tabiiy shirin.',
    details: ['Turi: urug‘li mayiz', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan uzum.',
    featured: true,
  },
  {
    slug: 'soyaki-mayiz',
    name: 'Soyaki mayiz',
    category: 'mayiz',
    image: '/images/mayiz.webp',
    short: 'Soyada quritilgan, to‘q rangli · 500 g',
    description: 'Soyada quritilgan uzumdan tayyorlangan mayiz. Yumshoqroq tuzilishi va mayin ta’mi bilan ajralib turadi.',
    details: ['Turi: soyada quritilgan mayiz', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan uzum.',
  },
  {
    slug: 'qora-quritilgan-orik',
    name: 'Qora quritilgan o‘rik',
    category: 'orik',
    image: '/images/orik.webp',
    short: 'To‘q rangli, danaksiz · 500 g',
    description: 'Tabiiy quritish jarayonida to‘q rangga kirgan, danaksiz o‘rik. Mevali choy dasturxoniga mos.',
    details: ['Turi: to‘q rangli, danaksiz o‘rik', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan o‘rik.',
  },
  {
    slug: 'kaisa-orik',
    name: 'Kaysa o‘rik',
    category: 'orik',
    image: '/images/orik.webp',
    short: 'Yirik, danaksiz · 500 g',
    description: 'Danagi olinib, butun holida quritilgan yirik o‘rik. Yumshoq va tabiiy shirin gazak.',
    details: ['Turi: butun, danaksiz kaysa o‘rik', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan o‘rik.',
  },
  {
    slug: 'qora-turshak',
    name: 'Qora turshak',
    category: 'turshak',
    image: '/images/turshak.webp',
    short: 'To‘q rangli, danakli · 500 g',
    description: 'To‘q rangli, danagi bilan quritilgan o‘rik. An’anaviy ta’mi va tabiiy shirinligi bilan ajralib turadi.',
    details: ['Turi: to‘q rangli turshak', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan o‘rik (danagi bilan).',
  },
  {
    slug: 'yirik-turshak',
    name: 'Yirik turshak',
    category: 'turshak',
    image: '/images/turshak.webp',
    short: 'Yirik donali, danakli · 500 g',
    description: 'Yirik o‘riklardan tayyorlangan, danagi bilan quritilgan turshak. Dasturxonga tortish uchun qulay.',
    details: ['Turi: yirik danakli turshak', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan o‘rik (danagi bilan).',
  },
  {
    slug: 'danakli-olxori-qoqi',
    name: 'Danakli olxo‘ri qoqi',
    category: 'olxori',
    image: '/images/olxori.webp',
    short: 'Danagi bilan quritilgan · 500 g',
    description: 'Danagi olinmasdan quritilgan olxo‘ri qoqi. Tabiiy meva ta’mini saqlagan shirin gazak.',
    details: ['Turi: danakli olxo‘ri qoqi', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan olxo‘ri (danagi bilan).',
  },
  {
    slug: 'yumshoq-olxori-qoqi',
    name: 'Yumshoq olxo‘ri qoqi',
    category: 'olxori',
    image: '/images/olxori.webp',
    short: 'Yumshoq, danaksiz · 500 g',
    description: 'Yumshoq tuzilishli, danagi olingan quritilgan olxo‘ri. Shirin gazak sifatida iste’mol qilishga mos.',
    details: ['Turi: yumshoq, danaksiz olxo‘ri qoqi', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan olxo‘ri.',
  },
  {
    slug: 'sariq-xurmo',
    name: 'Sariq xurmo',
    category: 'xurmo',
    image: '/images/xurmo.webp',
    short: 'Sarg‘ish rangli, mayin ta’mli · 500 g',
    description: 'Sarg‘ish rangli, tabiiy usulda quritilgan xurmo. Mayin shirin ta’mi bilan ajralib turadi.',
    details: ['Turi: sariq quritilgan xurmo', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan xurmo.',
  },
  {
    slug: 'qattiq-xurmo',
    name: 'Qattiq xurmo',
    category: 'xurmo',
    image: '/images/xurmo.webp',
    short: 'Zich tuzilishli · 500 g',
    description: 'Zichroq tuzilishli quritilgan xurmo. Yo‘lga olib yurish va choy bilan iste’mol qilishga qulay.',
    details: ['Turi: qattiq quritilgan xurmo', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan xurmo.',
  },
  {
    slug: 'qora-anjir',
    name: 'Qora anjir',
    category: 'anjir',
    image: '/images/anjir.webp',
    short: 'To‘q rangli, tabiiy shirin · 500 g',
    description: 'To‘q rangli quritilgan anjir. Shirin ta’mi va yumshoq tuzilishi bilan choy yoniga mos keladi.',
    details: ['Turi: qora quritilgan anjir', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan anjir.',
  },
  {
    slug: 'yirik-anjir',
    name: 'Yirik anjir',
    category: 'anjir',
    image: '/images/anjir.webp',
    short: 'Yirik dona, qo‘lda saralangan · 500 g',
    description: 'Yirik donali quritilgan anjir. Har bir dona saralanib, choy dasturxoni uchun tayyorlanadi.',
    details: ['Turi: yirik quritilgan anjir', 'Og‘irligi: 500 g'],
    materials: 'Tarkibi: quritilgan anjir.',
  },
  {
    slug: 'oilaviy-assorti',
    name: 'Oilaviy assorti',
    category: 'assorti',
    image: '/images/assorti.webp',
    short: 'Bir necha xil quritilgan meva · 1 kg',
    description: 'Mayiz, o‘rik, turshak, olxo‘ri va anjirdan tuzilgan oilaviy to‘plam. Tarkibi mavsumga qarab kelishiladi.',
    details: ['Tarkibi: quritilgan mevalar assortimenti', 'Og‘irligi: 1 kg'],
    materials: 'Tarkibi: quritilgan mevalar.',
  },
  {
    slug: 'quritilgan-olma',
    name: 'Quritilgan olma',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Yupqa kesilgan, nordon-shirin',
    description: 'Yupqa kesib quritilgan olma bo‘laklari. Yengil gazak yoki choyga qo‘shib iste’mol qilishga mos.',
    details: ['Turi: quritilgan olma bo‘laklari'],
    materials: 'Tarkibi: quritilgan olma.',
  },
  {
    slug: 'quritilgan-nok',
    name: 'Quritilgan nok',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Mayin, tabiiy shirin',
    description: 'Pishgan nokdan tayyorlangan quritilgan bo‘laklar. Mevaning o‘ziga xos xushbo‘y ta’mi saqlanadi.',
    details: ['Turi: quritilgan nok bo‘laklari'],
    materials: 'Tarkibi: quritilgan nok.',
  },
  {
    slug: 'quritilgan-shaftoli',
    name: 'Quritilgan shaftoli',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Xushbo‘y va sershira',
    description: 'Pishgan shaftolidan tayyorlangan quritilgan meva. Tabiiy shirinligi bilan choy yoniga mos.',
    details: ['Turi: quritilgan shaftoli'],
    materials: 'Tarkibi: quritilgan shaftoli.',
  },
  {
    slug: 'quritilgan-gilos',
    name: 'Quritilgan gilos',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Mayin nordon-shirin ta’m',
    description: 'Gilosdan tayyorlangan quritilgan meva. Shirinliklar, bo‘tqa va yengil gazaklar uchun ishlatish mumkin.',
    details: ['Turi: quritilgan gilos'],
    materials: 'Tarkibi: quritilgan gilos.',
  },
  {
    slug: 'quritilgan-tut',
    name: 'Quritilgan tut',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Mayda, tabiiy shirin',
    description: 'Tabiiy shirin ta’mli quritilgan tut. Choy yoniga yoki yengil gazak sifatida iste’mol qilishga mos.',
    details: ['Turi: quritilgan tut'],
    materials: 'Tarkibi: quritilgan tut.',
  },
  {
    slug: 'quritilgan-qovun',
    name: 'Quritilgan qovun',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Xushbo‘y, shirin qovun qoqi',
    description: 'Qovun bo‘laklaridan tayyorlangan shirin qoqi. O‘ziga xos xushbo‘y ta’mi bilan ajralib turadi.',
    details: ['Turi: quritilgan qovun bo‘laklari'],
    materials: 'Tarkibi: quritilgan qovun.',
  },
  {
    slug: 'quritilgan-banan',
    name: 'Quritilgan banan',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Shirin, yupqa bo‘lak',
    description: 'Banandan tayyorlangan quritilgan bo‘laklar. Sayrda yoki choy bilan yengil gazak sifatida qulay.',
    details: ['Turi: quritilgan banan bo‘laklari'],
    materials: 'Tarkibi: quritilgan banan.',
  },
  {
    slug: 'quritilgan-qulupnay',
    name: 'Quritilgan qulupnay',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Xushbo‘y, shirin-nordon',
    description: 'Qulupnaydan tayyorlangan quritilgan meva. Yeguliklar va shirinliklarga qo‘shish uchun ham mos.',
    details: ['Turi: quritilgan qulupnay'],
    materials: 'Tarkibi: quritilgan qulupnay.',
  },
  {
    slug: 'quritilgan-ananas',
    name: 'Quritilgan ananas',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Tropik meva, shirin ta’m',
    description: 'Ananas bo‘laklaridan tayyorlangan quritilgan meva. Tropik mevalarning xushbo‘y ta’mini yoqtiruvchilar uchun.',
    details: ['Turi: quritilgan ananas'],
    materials: 'Tarkibi: quritilgan ananas.',
  },
  {
    slug: 'quritilgan-kivi',
    name: 'Quritilgan kivi',
    category: 'qoqilar',
    image: '/images/assorti.webp',
    short: 'Yengil nordon-shirin',
    description: 'Kivining o‘ziga xos nordon-shirin ta’miga ega quritilgan bo‘laklar.',
    details: ['Turi: quritilgan kivi'],
    materials: 'Tarkibi: quritilgan kivi.',
  },
  {
    slug: 'yumshoq-finik',
    name: 'Yumshoq finik',
    category: 'finik',
    image: '/images/xurmo.webp',
    short: 'Yumshoq va shirali',
    description: 'Yumshoq tuzilishli, tabiiy shirin finik xurmosi. Choy yoniga yoki gazak sifatida mos.',
    details: ['Turi: yumshoq finik'],
    materials: 'Tarkibi: finik xurmosi.',
  },
  {
    slug: 'quruq-finik',
    name: 'Quruq finik',
    category: 'finik',
    image: '/images/xurmo.webp',
    short: 'Zich tuzilishli, tabiiy shirin',
    description: 'Zichroq tuzilishli finik xurmosi. Uzoqroq saqlash va yo‘lga olib yurish uchun qulay.',
    details: ['Turi: quruq finik'],
    materials: 'Tarkibi: finik xurmosi.',
  },
  {
    slug: 'danaksiz-finik',
    name: 'Danaksiz finik',
    category: 'finik',
    image: '/images/xurmo.webp',
    short: 'Danagi olingan, yegishga qulay',
    description: 'Danagi olinib tayyorlangan finik xurmosi. Darhol iste’mol qilish yoki shirinliklarga qo‘shish qulay.',
    details: ['Turi: danaksiz finik'],
    materials: 'Tarkibi: finik xurmosi.',
  },
  {
    slug: 'pista',
    name: 'Pista',
    category: 'yongoq',
    image: '/images/yongoq.webp',
    short: 'Qovurilmagan, tabiiy mag‘iz',
    description: 'Tabiiy pista mag‘izi. Gazak sifatida yoki turli taomlarga qo‘shib iste’mol qilish mumkin.',
    details: ['Turi: pista mag‘izi'],
    materials: 'Tarkibi: pista.',
  },
  {
    slug: 'keshyu',
    name: 'Keshyu',
    category: 'yongoq',
    image: '/images/bodom.webp',
    short: 'Butun mag‘iz, mayin ta’m',
    description: 'Mayin ta’mli keshyu mag‘izi. Gazak va shirinliklar uchun mos.',
    details: ['Turi: keshyu mag‘izi'],
    materials: 'Tarkibi: keshyu.',
  },
  {
    slug: 'funduk',
    name: 'Funduk',
    category: 'yongoq',
    image: '/images/yongoq.webp',
    short: 'Butun mag‘iz, xushbo‘y',
    description: 'Xushbo‘y funduk mag‘izi. Shirinliklarga qo‘shish yoki alohida gazak sifatida iste’mol qilish mumkin.',
    details: ['Turi: funduk mag‘izi'],
    materials: 'Tarkibi: funduk.',
  },
  {
    slug: 'yeryongoq',
    name: 'Yeryong‘oq',
    category: 'yongoq',
    image: '/images/bodom.webp',
    short: 'Tozalangan mag‘iz',
    description: 'Tozalangan yeryong‘oq mag‘izi. Kundalik gazak va turli yeguliklarga qo‘shish uchun mos.',
    details: ['Turi: yeryong‘oq mag‘izi'],
    materials: 'Tarkibi: yeryong‘oq.',
  },
]

export const products: Product[] = [...originalProducts, ...catalogAdditions]

export const bySlug = (slug: string) => products.find((p) => p.slug === slug)
export const featured = products.filter((p) => p.featured)
export const newArrivals = products.slice(0, 4)
